module.exports = pratt.PrattSharedLibs.instantsearch.core;